import { useGeneralStore } from '@core/stores/general'

// "/" shows the tenant's home page (webConfig.homePage, Updates by default). That page's route
// is registered again as Home ("/"), so it renders as the route's own page instead of inside
// pages/index.vue: a page rendered inside another page gets none of its definePageMeta
// (layout, requiresAuth, ...), and Nuxt warns about it in dev (NUXT_E1007).
// Runs before the initial navigation (app:created), so the server render already uses it.
export default defineNuxtPlugin(() => {
    const router = useRouter()
    const page = useGeneralStore().webConfig.homePage || { name: 'Updates' }
    const routes = router.getRoutes()
    const home = routes.find(r => r.name === 'Home')
    const target = routes.find(r => (page.name && r.name === page.name) || (page.path && r.path === page.path))

    if (!home || !target?.components?.default || target === home) return

    // Same name, so it replaces pages/index.vue's route (the fallback when there's no such page).
    router.addRoute({
        path: home.path,
        name: 'Home',
        components: target.components,
        props: target.props,
        meta: { ...target.meta },
    })
})
